/** PlanEditor + ApprovalBar — manual approval form inputs, portfolio selector,
 * sizing panel, and Prepare/Reject/Risk-Check buttons.
 */
import { Input } from "@/components/ui/input";
import { CheckCircle2, XCircle, ShieldCheck, Loader2 } from "lucide-react";
import { PROP } from "@/constants/testIds";
import PortfolioSelection from "./PortfolioSelection";
import PositionSizingPanel from "./PositionSizingPanel";

export default function PlanEditor({
  selectedPlanId, entry, stop, target, qty,
  onChange, sizing, portfolios, portfolioKey, onPortfolio,
  busy, verdict, onRiskCheck, onApprove, onReject,
}) {
  return (
    <section className="grid-cell" aria-labelledby="manual-approval-title">
      <div className="flex items-center gap-2 mb-3 flex-wrap">
        <div className="label-cap" id="manual-approval-title">Manual Approval</div>
        <span className="text-[10px] mono uppercase text-muted-foreground">Plan {selectedPlanId || "—"} · Small overrides allowed</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        <label className="block">
          <div className="label-cap mb-1">Entry</div>
          <Input value={entry} onChange={(e) => onChange("entry", e.target.value)} className="!rounded-none mono" data-testid={PROP.entryInput} aria-label="Entry price" inputMode="decimal"/>
        </label>
        <label className="block">
          <div className="label-cap mb-1">Stop</div>
          <Input value={stop} onChange={(e) => onChange("stop", e.target.value)} className="!rounded-none mono" data-testid={PROP.stopInput} aria-label="Stop price" inputMode="decimal"/>
        </label>
        <label className="block">
          <div className="label-cap mb-1">Target</div>
          <Input value={target} onChange={(e) => onChange("target", e.target.value)} className="!rounded-none mono" data-testid={PROP.targetInput} aria-label="Target price" inputMode="decimal"/>
        </label>
        <label className="block">
          <div className="label-cap mb-1">Qty</div>
          <Input value={qty} onChange={(e) => onChange("qty", e.target.value)} className="!rounded-none mono" data-testid={PROP.qtyInput} aria-label="Quantity" inputMode="numeric"/>
        </label>
      </div>

      <PortfolioSelection portfolios={portfolios} portfolioKey={portfolioKey} onSelect={onPortfolio}/>

      <PositionSizingPanel sizing={sizing}/>

      <div className="flex flex-wrap gap-2 mt-4">
        <button className="btn-outline" onClick={onRiskCheck} disabled={busy || !selectedPlanId} data-testid={PROP.riskCheckBtn}>
          {busy ? <Loader2 className="animate-spin" size={14}/> : <ShieldCheck size={14}/>} Run Risk Check
        </button>
        <button className="btn-primary" onClick={onApprove} disabled={busy || !verdict?.pass} data-testid={PROP.approveBtn}>
          <CheckCircle2 size={14}/> Prepare Trade
        </button>
        <button className="btn-danger" onClick={onReject} data-testid={PROP.rejectBtn}>
          <XCircle size={14}/> Reject
        </button>
      </div>
    </section>
  );
}
